import styled from 'styled-components';

export const SplashContainerStyled = styled.div`
  height: calc(100vh - 145px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
